import type { EntityState } from '@core/ngrx-legacy';
import { createEntityCollectionStore } from '@core/ngrx-legacy';
import type {
  ReportDashboardLibraryComponent,
  ReportDashboardTemplateComponent,
} from '@core/reports-types';

import { safeReportsStateSelector } from '../helpers/safe-selector';

const COMPONENTS_LIBRARY_SCOPE = 'library-components';
const TEMPLATES_LIBRARY_SCOPE = 'template-library-components';

const { actions, selectors, reducer, namespace, initialState } = createEntityCollectionStore<
  ReportDashboardLibraryComponent | ReportDashboardTemplateComponent
>()('ReportsLibraryComponents', {
  baseSelector: (
    root,
  ): EntityState<ReportDashboardLibraryComponent | ReportDashboardTemplateComponent> =>
    safeReportsStateSelector(root, namespace, initialState),
  idSelector: (component: ReportDashboardLibraryComponent | ReportDashboardTemplateComponent) =>
    component.libraryId,
  customActions: adapter => ({
    resetAll: state => adapter.resetAll(state),
    addMany: (
      state,
      payload: {
        components: ReportDashboardLibraryComponent[];
        scope: string;
      },
    ) => adapter.addMany(state, payload.components, { scope: payload.scope }),
  }),
});

export {
  COMPONENTS_LIBRARY_SCOPE,
  actions as ReportsLibraryComponentsActions,
  namespace as ReportsLibraryComponentsNamespace,
  reducer as ReportsLibraryComponentsReducer,
  selectors as ReportsLibraryComponentsSelectors,
  TEMPLATES_LIBRARY_SCOPE,
};
